module.exports = __webpack_public_path__ + "img/sl_one.e503cdd2.svg";